import React from 'react';
import toast from 'react-hot-toast';
import { useCart } from '../../context/CartContext';
import { getImageUrl } from '../../utils/imageUtils';
import './ComboSuggestionModal.css';

const ComboSuggestionModal = ({ combo, onClose }) => {
  const { addComboToCart } = useCart();

  if (!combo) return null;

  const handleAddCombo = async () => {
    try {
      const addedCount = await addComboToCart(combo);
      toast.success(`${combo.name} added to cart (${addedCount} item${addedCount === 1 ? '' : 's'})!`);
      onClose();
    } catch (err) {
      toast.error(err.message || 'Could not add combo. Please try again.');
    }
  };

  return (
    <div className="combo-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="combo-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="combo-modal-title"
      >
        <button type="button" className="combo-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <div className="combo-modal-badge">Combo Deal</div>
        <h2 id="combo-modal-title" className="combo-modal-title">{combo.name}</h2>
        {combo.description && (
          <p className="combo-modal-desc">{combo.description}</p>
        )}

        <div className="combo-modal-items">
          {combo.items.map((item) => (
            <div key={item.product} className="combo-modal-item">
              <img src={getImageUrl(item.image_url)} alt={item.product_name} />
              <div>
                <span className="combo-item-name">{item.product_name}</span>
                <span className="combo-item-qty">× {item.quantity}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="combo-modal-pricing">
          <span className="combo-price-old">₹{combo.individual_total}</span>
          <span className="combo-price-new">₹{combo.combo_price}</span>
          <span className="combo-savings">Save ₹{combo.savings}</span>
        </div>

        <button type="button" className="combo-modal-cta" onClick={handleAddCombo}>
          Add Complete Combo — ₹{combo.combo_price}
        </button>
        <button type="button" className="combo-modal-skip" onClick={onClose}>
          No thanks, continue shopping
        </button>
      </div>
    </div>
  );
};

export default ComboSuggestionModal;
